export default [
	{
		value: 1,
		label: 'Support',
		status: 1,
	},
	{
		value: 2,
		label: 'Marketing',
		status: 1,
	},
	{
		value: 3,
		label: 'Call',
		status: 1,
	},
	{
		value: 4,
		label: 'Remark',
		status: 1,
	},
	{
		value: 5,
		label: 'Feedback',
		status: 1,
	},
	{
		value: 6,
		label: 'Comment',
		status: 1,
	},
	{
		value: 7,
		label: 'Email',
		status: 1,
	},
	{
		value: 8,
		label: 'Monitoring',
		status: 0,
	},
	{
		value: 9,
		label: 'Monitor',
		status: 1,
	},
];
